<div class="quiz-modal">
    <div class="modal-overlay"></div>
    <div class="modal-content quiz-page">
        <button type="button" class="modal-close" (click)="feebackClose()">
            <i class="fas fa-times"></i>
        </button>
        <form [formGroup]="feedbackForm" (ngSubmit)="submitFeedback()">

            <div class="feedback-modal">

                <div class="feedback-header">
                    <h2>We loved having you in session!🤩</h2>

                    <!-- <p>
                Thank you for attending the training. Please take a moment to
                rate your experience and share your valuable feedback to help us
                improve future sessions.
            </p> -->
                </div>

                <div class="feedback-body">

                    <h4>
                        Your feedback is valuable to us—please rate your experience below.
                    </h4>

                    <div class="rating-emojis">
                        <span *ngFor="let emoji of ['☹️', '😒', '😐', '☺️', '🤩']; let i = index"
                            [class.active]="selectedRating === i + 1" (click)="setRating(i + 1)">
                            {{ emoji }}
                        <span *ngIf="selectedRating === i + 1" class="correct-icon"></span>
                        </span>
                       
                    </div>

                    <textarea formControlName="remarks" rows="4"
                        placeholder="Tell us what you liked or what we can improve...">
                    </textarea>

                </div>

                <div class="feedback-footer">

                    <button class="submit-btn" type="button" (click)="submitFeedback()">

                        <i class="fas fa-paper-plane"></i>
                        Submit Feedback

                    </button>

                </div>

            </div>

        </form>
    </div>
</div>